import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import './index.scss';
import { ZMFScorePDFUrl } from '../../../configs/ContactConfig';
import ConstCommon from '../../common/Const';
import { withSyncDragCode } from '../../common/sync-drag-code';
import {
  getCodeFromQuery,
  getCurrentDate,
  getQueryParams,
  removeDragCode,
  syncComponentSelector,
} from '../../helpers/Common';
import SwitchTab from './common/switch-tab';
import SearchBox from './common/search-box';
import GroupButton from '../common/header/group-button';
import ScoreBox from './common/score-box';
import Notice from './common/notifications';
import { Export } from './../../common/export';
import { ChanelConfig } from '../../../configs/GlobalConfig';
import MessageHub from '../../../core/signalr/SignalrMessageHub';
import PreRender from './../../common/PreRender';
import { compose } from 'redux';
import {
  REDUCER_NAME,
  changeTab,
  fetchInfoTicker,
  subscribeRealTimeTick,
  fetchCompanyScore,
  setCondition,
} from './reducer';
import { Provider } from '../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../common/ComponentNameContext';
import FACheckup from './tab-content/FACheckup';
import ZMFScore from './tab-content/ZMFScore';
import ScrollComponent from './../../common/ScrollComponent';

class FinancialAnalysis extends Component {
  constructor(props) {
    super(props);

    const { setCondition, id, changeTab, tab } = this.props;
    const codeFromQuery = getCodeFromQuery(['stock']);

    if (codeFromQuery) {
      setCondition(id, codeFromQuery);
    }

    if (tab) {
      changeTab(id, tab);
    }
  }

  handleSwitchTab = currentTab => {
    const { changeTab, id } = this.props;
    changeTab(id, currentTab);
  };

  onReceivePriceData = data => {
    const { searchParams, id, subscribeRealTimeTick } = this.props;
    const { code } = searchParams;
    subscribeRealTimeTick(id, data, code);
  };

  componentDidMount() {
    const { glContainer } = this.props;

    if (!getQueryParams('code')) {
      this.fetchData();
    }

    MessageHub.subscribe(ChanelConfig.TickChanel, this.onReceivePriceData);
    removeDragCode(glContainer);
  }

  componentWillUnmount() {
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.onReceivePriceData);
  }

  fetchData = () => {
    const { fetchInfoTicker, fetchCompanyScore, id, searchParams } = this.props;
    const { code } = searchParams;
    fetchInfoTicker(id, code);
    fetchCompanyScore(id, code);
  };

  getZmfExportName = () => {
    const { searchParams } = this.props;
    return (
      I18n.t('common.export.financialAnalysis.zmfScore', {
        date: getCurrentDate(),
        ticker: searchParams.displayCode,
      }) + '.png'
    );
  };

  render() {
    const { id, currentTab, searchParams } = this.props;

    return (
      <PreRender {...this.props}>
        <ComponentNameProvider
          value={ConstCommon.listComponent.FinancialAnalysis}
        >
          <Provider value={id}>
            <ScrollComponent appendClassName="fa-wrapper">
              <div className=" px-20 fa-content d-flex flex-column h-100">
                <div className="pt-8 sticky">
                  <SwitchTab
                    handleSwitchTab={this.handleSwitchTab}
                    currentTab={currentTab}
                  />
                </div>
                <div className="d-flex flex-column flex-fill">
                  <div className="fa-top-content flex-shrink-0">
                    <div className="d-flex align-items-center">
                      <SearchBox />
                      <ScoreBox />
                      <GroupButton code={searchParams.displayCode} />
                      <Notice id={id} />
                    </div>
                    {currentTab === 3 && (
                      <div
                        className="align-self-end d-flex"
                        style={{ paddingBottom: 10 }}
                      >
                        <Export
                          exportId="zmf-content-export"
                          exportName={this.getZmfExportName()}
                        />
                      </div>
                    )}
                  </div>
                  <div className="fa-body-content d-flex flex-column flex-fill mb-10">
                    {currentTab === 1 && <FACheckup />}
                    {currentTab === 3 && <ZMFScore />}
                  </div>
                </div>
                <div className="fa-footer-content">
                  {currentTab === 3 && (
                    <div
                      style={{
                        fontSize: 10,
                        fontWeight: 300,
                        fontStyle: 'Italic',
                        marginTop: 3,
                      }}
                      className="text-nowrap"
                      dangerouslySetInnerHTML={{
                        __html: I18n.t('financialAnalysis.zmfFooter', {
                          url: ZMFScorePDFUrl,
                        }),
                      }}
                    />
                  )}
                </div>
              </div>
            </ScrollComponent>
          </Provider>
        </ComponentNameProvider>
      </PreRender>
    );
  }
}

const mapStateToProps = (state, { id, glContainer }) => {
  return {
    i18n: state.i18n,
    currentTab: state[REDUCER_NAME].listMultiComponent[id].currentTab,
    searchParams: state[REDUCER_NAME].listMultiComponent[id].searchParams,
    syncType: syncComponentSelector(
      state,
      ConstCommon.listComponent.FinancialAnalysis,
      id,
    ),
  };
};

const mapDispatchToProps = {
  changeTab,
  fetchInfoTicker,
  fetchCompanyScore,
  subscribeRealTimeTick,
  setCondition,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withSyncDragCode,
)(FinancialAnalysis);
